module.exports = __webpack_public_path__ + "img/4.5a8512f0.jpg";